module.exports = __webpack_public_path__ + "static/img_0577-1323ee21cc333a61839826357f26193e.webp";